module.exports = __webpack_public_path__ + "static/fabric-table-resize-6b02a8ef9e7fc662c3f3b89612585285.png";